type TokenResolver = (token: string) => void;
type TokenRejector = (reason?: any) => void;

let token: string | null = null;
let isCanceled = false;

let pendingResolvers: { resolve: TokenResolver; reject: TokenRejector }[] = [];

export function setTokenReady(newToken: string) {
    if (isCanceled) return;
    token = newToken;
    pendingResolvers.forEach(({ resolve }) => resolve(token!));
    pendingResolvers = [];
}

export function resetToken() {
    token = null;
    isCanceled = true;
    pendingResolvers.forEach(({ reject }) => reject(new Error('토큰 초기화됨')));
    pendingResolvers = [];
}

export function waitForToken(): Promise<string> {
    if (token) return Promise.resolve(token);
    if (isCanceled) return Promise.reject(new Error('이미 토큰이 초기화됨'));

    // // 세션스토리지에서 토큰 확인
    const storedToken = sessionStorage.getItem('persist-token');
    if (!token && storedToken) {
        const parsedToken = JSON.parse(storedToken);
        const sToken = parsedToken?.state?.sToken;
        if (sToken) {
            token = sToken;
            return Promise.resolve(sToken);
        }
    }

    return new Promise((resolve, reject) => {
        pendingResolvers.push({ resolve, reject });
    });
}

export function initTokenManager() {
    pendingResolvers.forEach(({ reject }) => reject(new Error('토큰 상태 초기화됨')));
    token = null;
    isCanceled = false;
    pendingResolvers = [];
}
